import React, { useState, useEffect, useRef } from "react";
import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

import logo from './img/logo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({ open: false, message: "" });
  const [showForm, setShowForm] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'ccc';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage")

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }
  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="captcha" ref={nodeRef}>
        <div className="login-ccc-container text-align-center">
          <div className="login-ccc-header">
            <img src={logo} alt="logo" className="logo-ccc" />
          </div>
          <div className="text-div">
            <h2 className="text">
              <p className="ccc-login-subtitle">{translate("LoginSubtitle")}</p>
            </h2>
          </div>
          <div className="login-ccc-body">
            <Form onSubmit={(event) => onSubmit(event)}>
              <input
                className="user-input-ccc"
                disabled={onLogin}
                onChange={(e) => setUsername(e.target.value)}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
                placeholder="Usuario"
              />
              <input
                className="user-input-ccc"
                required={true}
                disabled={onLogin}
                onChange={(e) => setPassword(e.target.value)}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
                placeholder="Contraseña"
              />
              <div>
                {!onLogin ?
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    className="enter-ccc"
                    type="submit"
                    name="submit"
                    disabled={!props.turnstileSuccess}
                  >
                    <p className="ccc-signIn-subtitle">{translate("ButtonEnter")}</p>
                  </button> :
                  <Progress animated color="danger" value={100} />}
              </div>
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <p className='ccc-link-left'>
                <a href="https://webservices.viaccc.com/ccc_play.php">
                  <p className="ccc-forgotPassword-subtitle">{translate("forgotPassowrd")}</p>
                </a>
              </p>
              {
                checkDeviceIOS() ? '' : <p className='entel-link-rigth'>
                  <a href="https://webservices.viaccc.com/ccc_play.php">
                    <p className="ccc-signUp-subtitle">{translate("signUp")}</p>
                  </a>
                </p>
              }
            </Form>
          </div>
        </div>
        <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
      </div>

    </CSSTransition>
  );

}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
